import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '../services';

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
    const envService = inject(EnvironmentService);
    const apiKey = envService.apiKey;

    if (apiKey && req.url.includes('planning-projects')) {
        req = req.clone({
            setHeaders: { 'X-APPLICATION-API-KEY': apiKey }
        });
    }

    return next(req);
};
